import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    id: 'shared.navigation.next-page',
    defaultMessage: 'Next',
  },
  prev: {
    id: 'shared.navigation.previous-page',
    defaultMessage: 'Prev',
  },
});



// WEBPACK FOOTER //
// ./src/shared/translations/navigation.js